import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { I18N_NS } from "Config/i18n";
import { Row, Dropdown, message, Tooltip } from "antd";
import { withModal } from "Components/General/Modal/ModalContext";
import { modalProps } from "Pages/Project/QA/utils/modalProps";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "Components/General/Button";
import { documentsQueryStore } from "../../Stores/DocumentsQueryStore";
import { RouterStore } from "Config/CustomBrowserRouter";
import { projectsDataStore } from "Stores";
import { SaveQueryFormProps, SaveQueryForm } from "./SaveQueryForm";
import { documentsSearchStore } from "../../Stores/DocumentsSearchStore";
import { documentsTableStore } from "../../Stores/DocumentsTableStore";
import { ItemType } from "antd/lib/menu/interface";
import { WithModal } from "Components/General/Modal/withModal";

interface SearchQueriesDropdownProps extends WithTranslation, WithModal {
  style?: React.CSSProperties;
}

export const SearchQueriesDropdown = withTranslation(I18N_NS.PROJECT)(
  withModal(
    observer(
      class extends React.Component<SearchQueriesDropdownProps> {
        componentDidMount() {
          (async () => {
            if (documentsQueryStore.state === "RAW") {
              await documentsQueryStore.fetchQueries();
            }
          })();
        }

        handleExecuteQuery = async ({ key: id }) => {
          const hide = message.loading(this.props.t("Loading..."), 0);
          try {
            await documentsQueryStore.executeQuery(+id);
            const folderId = documentsSearchStore.searchReqQueries.folderId || documentsTableStore.rootFolderId;
            RouterStore.push(
              `/project/${projectsDataStore.projectId}/documents/docs/search-results?folderId=${folderId}`
            );
          } catch (error) {
            throw error;
          } finally {
            hide();
          }
        };

        get queries(): ItemType[] {
          const { data } = documentsQueryStore;
          const { t } = this.props;

          if (!documentsQueryStore.data.length) {
            return [
              {
                key: "1",
                label: t("No saved queries"),
                type: "group",
              },
            ];
          }

          return data.map((item: API_SearchQuery) => ({
            key: `${item.id}`,
            label: (
              <Row justify="space-between">
                <Button
                  size="small"
                  style={{
                    marginRight: "10px",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    maxWidth: 400,
                  }}
                >
                  {item.name}
                </Button>
                <div>
                  <span
                    style={{ marginRight: "10px" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.props.showModal<Partial<SaveQueryFormProps>>(SaveQueryForm, {
                        modalProps: { ...modalProps, title: t("Edit query"), destroyOnHidden: true },
                        componentProps: { initialData: item, isEdit: true },
                      });
                    }}
                  >
                    <FontAwesomeIcon icon={["fas", "edit"]} size="1x" fixedWidth={true} />
                  </span>
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      documentsQueryStore.deleteQuery(item.id);
                    }}
                  >
                    <FontAwesomeIcon icon={["fas", "trash"]} size="1x" fixedWidth={true} />
                  </span>
                </div>
              </Row>
            ),
          }));
        }

        render() {
          return (
            <Tooltip title={this.props.t("My saved queries")}>
              <div>
                <Dropdown
                  menu={{
                    items: this.queries,
                    onClick: this.handleExecuteQuery,
                    style: { maxHeight: "300px", overflowY: "auto" },
                  }}
                  trigger={["click"]}
                  destroyOnHidden={true}
                >
                  <div className="searchbar-options star">
                    <FontAwesomeIcon icon={["far", "star"]} size="1x" fixedWidth={true} />
                  </div>
                </Dropdown>
              </div>
            </Tooltip>
          );
        }
      }
    )
  )
);
